module.exports = __webpack_public_path__ + "fonts/lato-regular-greek.91b00cf.woff2";